import formAPIhistoryofpresentillness from "./historyofpresentillness";


var formattedOutput = null;

const formAPIModelhistoryofpresentillness = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPIhistoryofpresentillness(item));


  return formattedOutput
};

export default formAPIModelhistoryofpresentillness